import io from 'socket.io-client';
import { socketURL } from '../utils/setting';
const reason = 'io server disconnect'; // the disconnection was initiated by the server, you need to reconnect manually


const socketClient = {
    state: {
    },
    reducers: {
        setState(state, payload) {
            state = {...state, ...payload};
            return {...state};
        },
    },
    effects: (dispatch) => ({
        connect(payload, rootState) {
            const _this = this;
            const { user, developerAccount } = rootState;
            const { roleId } = user.user
            let serviceCode = roleId.serviceCode || "masspa"
            const socket = io.connect(`${socketURL}/admin?token=${user.token}`);
            window.socket = socket;
            
            socket.on('connect', function (res) {
                console.log('connected', res)
            });

            socket.on(`device_event_${serviceCode}`, function (res) {
                let listDevices = developerAccount.listDevices.concat([]) // create new array
                if (res.status) {
                    listDevices.push({
                        deviceId: res.deviceId,
                        versionOS: res.versionOS,
                        model: res.model,
                        status: res.status,
                    })
                }
                else{
                    let indexDevice = listDevices.findIndex((device) => {
                    return device.deviceId === res.deviceId
                    })
                    listDevices.splice(indexDevice, 1);
                }
                dispatch.developerAccount.setState({listDevices:listDevices})
            })

            socket.on('connect_error', (err) => {
                console.log('connect_error', err)
            })
            socket.on('error', (err) => {
                console.log('error', err)
            })
            this.disconnect()
        },
        disconnect(payload, rootState) {
            const socket = window.socket;
            socket.on('disconnect', function(res){
                console.log('socket disconnect', res)
                if(res === 'ping timeout') {
                    this.connect()
                }
            }, function(err){
                console.log(err);
                
            });
        },
    })
};


export default socketClient;